import { Component, forwardRef } from "react";
import { createPortal } from "react-dom";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { exhibitionId, orderStatusActionId, serviceTypeId, toastError, toastSuccess, DOC_BASE_URL, countryActionId, exhibitorNameActionId, primaryChapterListActionId } from "../../../utils/constants";
import { getVendorExhibitionList_action, markOrderSeen_action } from '../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_exhibition_list_action'
import { raiseManualForm_action, markManualFormInvoicePaid_action } from '../../../actions/vendor_module_action/vendor_order_action'
import { primaryChapterAdd_action, getPreviewDetails_action, deleteChapterDoc_action } from '../../../actions/primary_chapter_action';
import moment from "moment";
import Modal from "react-modal";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import ImageCapture from "../../../utils/ImageCapture";
import * as XLSX from "xlsx";

//Manual Page 
import FasciaForm from "../../exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import ExhibitorBadge from "../../exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge";
import ExhibitorDetails from "../../exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import VisaApplication from "../../exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationList";
import EDirectoryList from "../../exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_list";
import KeywordsInformation from "../../exhibitor_module/manual_forms/forms/keywords_information_form/keywords_information";
import StallDesign from "../../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import AdditionalFurniture from "../../exhibitor_module/manual_forms/forms/additional furniture/additional_furniture";
import StallPossession from "../../exhibitor_module/manual_forms/forms/stall_possesion/stall_possesion";
import PowerConnection from "../../exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import FreightForward from "../../exhibitor_module/manual_forms/forms/freight_forward/freight_forward";
import Water from "../../exhibitor_module/manual_forms/forms/water_form/water";
import AirConnectionApplication from "../../exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import CarPassesApplication from "../../exhibitor_module/manual_forms/forms/car_passes_application/car_passes_application";
import LiquareLicense from "../../exhibitor_module/manual_forms/forms/liquare_license/liquare_license";
import LeadRetrievalConnectionApplication from "../../exhibitor_module/manual_forms/forms/leadRetrievalConnectionApplication/leadRetrievalConnectionApplication";
import MeetingRoomRequestForm from "../../exhibitor_module/manual_forms/forms/Meeting room request form/MeetingRoomRequestForm";
import DelegateMeeting from "../../exhibitor_module/manual_forms/forms/delegate_meeting/delegate_meeting";
import VisitorMeetingApplication from "../../exhibitor_module/manual_forms/forms/visitor_meeting_application/visitor_meeting_application";
import InternetConnection from "../../exhibitor_module/manual_forms/forms/internet_connection/internet_connection";
import HousekeepingConnection from "../../exhibitor_module/manual_forms/forms/housekeeping_connection/housekeeping_connection";
import SecurityApplication from "../../exhibitor_module/manual_forms/forms/security_application/security_application";
import CateringServices from "../../exhibitor_module/manual_forms/forms/catering_services/catering_services";
import HostHostessRequirements from "../../exhibitor_module/manual_forms/forms/host_hostess_requirement/host_hostess_requirement";
import BrandingOpportunityAndAdvertisement from "../../exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";
import RentalAudioAndVideoEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import ExhibitorContractorBadgeApplication from "../../exhibitor_module/manual_forms/forms/exhibitor_contractor_badgeApplication/exhibitor_contractor_badgeApplication";
import PlantAndBeautification from "../../exhibitor_module/manual_forms/forms/PlantAndBeautification/PlantAndBeautification";
import RentalAudioAndVedioEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";


const styles = {
  width: '100%',
};

class VendorExhibitionList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      vendorRegistrationList: [],
      vendorServiceList: [],
      currentPage: 1,
      ExhibitionID: "",
      exhibitionList: [],
      ServiceID: "",
      StatusID: "",
      serviceTypeList: [],
      orderStatusList: [],
      showRaiseModal: false,
      showMarkPaidModal: false,
      selectedRecord: null,
      selectedFile: null,
      useCamera: false,
      documentFile: { FileName: "", FilePath: "", FileType: "" },
      showVideoModal: false,
      dashboardData: null,
      showCameraModal: false,
      //modal
      isManualFormModalOpen: false,
      selectedServiceName: null,
      isFreightForwardAddMode: false,
      isCompanyModalOpen: false,
      selectedCompanyData: null,
      // Exhibitor selector & Machine management state
      exhibitorDropdownList: [],
      selectedExhibitorOption: null,
      countryList: [],
      isAddMachineModalOpen: false,
      existingMachinesList: [],
      exhStallData: {},
      isLoadingMachines: false,
      isSavingMachine: false,
      editingMachineIndex: -1,
      machineForm: {
        ManufacturerName: "",
        ManufacturingCountry: "",
        isMachine: false,
        IsAccessory: false,
        isBrochure: false,
        MachineDetails: "",
        HSNCode: "",
        Length: "",
        Breadth: "",
        Area: 0,
        Height: "",
        FloorCapacity: "",
        MachineWeight: "",
        DocumentFile: "",
        DocumentName: "",
        DocumentType: "",
        DocumentPath: "",
        DocDeleted: true,
      },
      machineFormErrors: {},
    };
    this.loadingCount = 0;
    this.updateItem = this.updateItem.bind(this)
    this.onViewClick = this.onViewClick.bind(this)
    this.pollingTimer = null
  }

  // Keep the loader visible as long as any request is still in flight
  startLoading = () => {
    this.loadingCount += 1;
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });
    }
  };

  stopLoading = () => {
    this.loadingCount = Math.max(0, this.loadingCount - 1);
    if (this.loadingCount === 0) {
      this.setState({ isLoading: false });
    }
  };

  async componentDidMount() {
    this.startLoading();
    try {
      await Promise.all([
        this.getFillList(exhibitionId, '', '', '', '', ''),
        this.getFillList(serviceTypeId, '', '', '', '', ''),
        this.getFillList(orderStatusActionId, '', '', '', '', ''),
        this.getFillList(countryActionId, '', '', '', '', '')
      ]);

      const loginData = JSON.parse(sessionStorage.getItem('loginDataSS'));
      const isVendor = loginData && (loginData.RoleID === 7 || loginData.RoleID === 17);
      const filterStatusID = sessionStorage.getItem('filterStatusID') || '';
      const filterServiceName = sessionStorage.getItem('filterServiceName');
      const exhibitionID = sessionStorage.getItem('sessionExhibitionID');

      let targetExhibitionID = this.state.ExhibitionID;
      if (isVendor && exhibitionID) {
        targetExhibitionID = exhibitionID;
      }

      let targetServiceID = '';
      if (filterServiceName && this.state.serviceTypeList?.length > 0) {
        const matchedService = this.state.serviceTypeList.find(
          s => (s.Name || '').trim().toLowerCase() === filterServiceName.trim().toLowerCase()
        );
        if (matchedService) {
          targetServiceID = matchedService.ServiceID;
        }
      }

      sessionStorage.removeItem('filterStatusID');
      sessionStorage.removeItem('filterServiceName');

      await new Promise((resolve) => {
        this.setState({
          ExhibitionID: targetExhibitionID,
          StatusID: filterStatusID,
          ServiceID: targetServiceID
        }, resolve);
      });

      // Populate exhibitor dropdown for initial exhibition
      await this.getFillList(exhibitorNameActionId, targetExhibitionID || exhibitionID || '', '', '', '', '');

      await this.getVendorExhibitionList();
    } catch (err) {
      console.log('Error in componentDidMount:', err);
    } finally {
      this.stopLoading();
      this.startPolling();
    }
  }

  componentWillUnmount() {
    this.stopPolling()
    this.loadingCount = 0;
  }

  // Refresh the list every 15s in the background (no page reload, no loader flicker)
  startPolling() {
    this.stopPolling()
    this.pollingTimer = setInterval(() => {
      // Skip the refresh while the user is busy in a modal so their work isn't disturbed
      const isAnyModalOpen = this.state.showRaiseModal || this.state.showMarkPaidModal ||
        this.state.showCameraModal || this.state.isManualFormModalOpen ||
        this.state.isCompanyModalOpen || this.state.showVideoModal ||
        this.state.isAddMachineModalOpen
      if (isAnyModalOpen || document.hidden) {
        return
      }
      this.getVendorExhibitionList(true)
    }, 15000)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  openModal(ServiceName) {
    if (ServiceName === "Fascia") {
      return <FasciaForm />;
    } else if ((ServiceName || "").trim() === "Exhibitor Paid Badges") {
      return <ExhibitorBadge />;
    } else if ((ServiceName || "").trim() === "exhibitorDetails") {
      return <ExhibitorDetails />;
    } else if ((ServiceName || "").trim() === "Visa Application  ") {
      return <VisaApplication />;
    } else if ((ServiceName || "").trim() === "edirectoryList") {
      return <EDirectoryList />;
    } else if ((ServiceName || "").trim() === "Keywords") {
      return <KeywordsInformation />;
    } else if ((ServiceName || "").trim() === "Stall Design") {
      return <StallDesign />;
    } else if ((ServiceName || "").trim() === "Furniture") {
      return <AdditionalFurniture />;
    } else if ((ServiceName || "").trim() === "Stall Possession") {
      return <StallPossession />;
    } else if ((ServiceName || "").trim() === "Power") {
      return <PowerConnection />;
    } else if ((ServiceName || "").trim() === "Freight Forwarders") {
      if (this.state.isFreightForwardAddMode) {
        return (
          <FreightForward
            key={this.state.selectedExhibitorOption?.value || 'ff'}
            isModal={true}
            isSubmissionMode={true}
            onClose={this.handleCloseFreightForward}
            onSuccess={() => {
              toastSuccess("Form submitted successfully!");
              this.handleCloseFreightForward();
              this.getVendorExhibitionList(true);
            }}
          />
        );
      } else {
        return (
          <FreightForward
            key={sessionStorage.getItem('ExhRegistrationIDSS') || 'ff-view'}
            isModal={true}
            isSubmissionMode={false}
          />
        );
      }
    } else if ((ServiceName || "").trim() === "Water") {
      return <Water />;
    } else if ((ServiceName || "").trim() === "Air") {
      return <AirConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Car Passes") {
      return <CarPassesApplication />;
    } else if (ServiceName === "Liquor License") {
      return <LiquareLicense />;
    } else if ((ServiceName || "").trim() === "Lead Retrieval") {
      return <LeadRetrievalConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Meeting Room") {
      return <MeetingRoomRequestForm />;
    } else if ((ServiceName || "").trim() === "delegateMeeting") {
      return <DelegateMeeting />;
    } else if ((ServiceName || "").trim() === "visitorMeetingApplication") {
      return <VisitorMeetingApplication />;
    } else if ((ServiceName || "").trim() === "Internet Connection") {
      return <InternetConnection />;
    } else if ((ServiceName || "").trim() === "Housekeeping") {
      return <HousekeepingConnection />;
    } else if ((ServiceName || "").trim() === "Security") {
      return <SecurityApplication />;
    } else if ((ServiceName || "").trim() === "Catering") {
      return <CateringServices />;
    } else if ((ServiceName || "").trim() === "Host and Hostess") {
      return <HostHostessRequirements />;
    } else if ((ServiceName || "").trim() === "Branding Opportunity") {
      return <BrandingOpportunityAndAdvertisement />;
    } else if ((ServiceName || "").trim() === "AV Equipments") {
      return <RentalAudioAndVideoEquipment />;
    } else if ((ServiceName || "").trim() === "Contractor Badge") {
      return <ExhibitorContractorBadgeApplication />;
    } else if ((ServiceName || "").trim() === "plantAndBeautification") {
      return <PlantAndBeautification />;
    } else {
      return null; // or <NotFound />
    }
  }
  handleManualFormModal = (serviceName, ExhRegistrationID) => {
    sessionStorage.setItem("ExhRegistrationIDSS", ExhRegistrationID);
    this.setState({
      isManualFormModalOpen: true,
      selectedServiceName: serviceName,
      isFreightForwardAddMode: false,
      selectedExhibitorOption: null,
    });
  };

  handleCompanyModal = (data) => {
    sessionStorage.setItem("ExhRegistrationIDSS", data.ExhRegistrationID);
    this.setState({
      isCompanyModalOpen: true,
      selectedCompanyData: data,
    });
  };

  handleCloseCompanyModal = () => {
    sessionStorage.removeItem("ExhRegistrationIDSS");
    this.setState({
      isCompanyModalOpen: false,
      selectedCompanyData: null,
      selectedExhibitorOption: null,
    });
  };

  // Exhibitor selection handler
  handleExhibitorChange = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      sessionStorage.setItem("ExhRegistrationIDSS", selectedOption.value);
      this.setState({
        selectedExhibitorOption: selectedOption,
      });
    } else {
      sessionStorage.removeItem("ExhRegistrationIDSS");
      this.setState({
        selectedExhibitorOption: null,
      });
    }
  };

  // Button 1: Freight Forward Form submission against exhibitor
  handleOpenFreightForward = () => {
    sessionStorage.removeItem("ExhRegistrationIDSS");
    this.setState({
      isManualFormModalOpen: true,
      selectedServiceName: "Freight Forwarders",
      selectedExhibitorOption: null,
      isFreightForwardAddMode: true,
    });
  };

  handleCloseFreightForward = () => {
    sessionStorage.removeItem("ExhRegistrationIDSS");
    this.setState({
      isManualFormModalOpen: false,
      selectedServiceName: null,
      selectedExhibitorOption: null,
      isFreightForwardAddMode: false,
    });
  };

  // Button 2: Add machines against exhibitor
  handleOpenAddMachineModal = () => {
    sessionStorage.removeItem("ExhRegistrationIDSS");
    this.setState({
      isAddMachineModalOpen: true,
      selectedExhibitorOption: null,
      existingMachinesList: [],
      exhStallData: {},
    });
    this.resetMachineForm();
  };

  handleCloseAddMachineModal = () => {
    sessionStorage.removeItem("ExhRegistrationIDSS");
    this.setState({
      isAddMachineModalOpen: false,
      selectedExhibitorOption: null,
      existingMachinesList: [],
      exhStallData: {},
    });
    this.resetMachineForm();
  };

  loadExhibitorMachines = async (exhRegistrationID, exhibitionID) => {
    try {
      const exbId = exhibitionID || sessionStorage.getItem("sessionExhibitionID") || "";
      // 1. Fetch stall preview details
      const previewRes = await this.props.getPreviewDetails_action(exhRegistrationID, exbId);
      const exhStallData = (previewRes && previewRes.data && previewRes.data[0]) ? previewRes.data[0] : {};

      // 2. Fetch existing machines / chapters
      const fillRes = await this.props.fill_action(primaryChapterListActionId, exbId, "", "", "", exhRegistrationID);
      const resData = (fillRes && fillRes.data) ? fillRes.data : {};
      const primaryDetails = resData['primaryChapterListDetails'] || resData;
      const machines = [];
      ['level2', 'level3', 'level4'].forEach(levelKey => {
        if (Array.isArray(primaryDetails[levelKey])) {
          primaryDetails[levelKey].forEach(item => {
            if ((item.IsSelect && item.IsCheckbox) || item.isMachine || item.IsAccessory || item.isBrochure || (item.ManufacturerName && item.ManufacturerName.trim())) {
              const length = parseFloat(item.Length) || 0;
              const breadth = parseFloat(item.Breadth) || 0;
              const docPath = item.Document || item.DocumentPath || '';
              const docName = item.DocumentName || (docPath ? docPath.split('/').pop() : '');
              machines.push({
                ...item,
                Length: length,
                Breadth: breadth,
                Area: length * breadth,
                Height: parseFloat(item.Height) || 0,
                FloorCapacity: item.FloorCapacity !== undefined ? item.FloorCapacity : 0,
                MachineWeight: item.MachineWeight !== undefined ? item.MachineWeight : 0,
                DocumentPath: docPath,
                DocumentName: docName,
                DocumentFile: item.DocumentFile || '',
                DocumentType: item.DocumentType || '',
                DocDeleted: docPath || item.DocumentFile ? false : true,
                isMachine: !!item.isMachine,
                isBrochure: !!item.isBrochure,
                IsAccessory: !!item.IsAccessory,
              });
            }
          });
        }
      });
      if (Array.isArray(primaryDetails['level0'])) {
        primaryDetails['level0'].forEach(item => {
          if (item.isMachine || item.IsAccessory || item.isBrochure || (item.ManufacturerName && item.ManufacturerName.trim())) {
            const length = parseFloat(item.Length) || 0;
            const breadth = parseFloat(item.Breadth) || 0;
            const docPath = item.Document || item.DocumentPath || '';
            const docName = item.DocumentName || (docPath ? docPath.split('/').pop() : '');
            machines.push({
              ...item,
              Length: length,
              Breadth: breadth,
              Area: length * breadth,
              Height: parseFloat(item.Height) || 0,
              FloorCapacity: item.FloorCapacity !== undefined ? item.FloorCapacity : 0,
              MachineWeight: item.MachineWeight !== undefined ? item.MachineWeight : 0,
              DocumentPath: docPath,
              DocumentName: docName,
              DocumentFile: item.DocumentFile || '',
              DocumentType: item.DocumentType || '',
              DocDeleted: docPath || item.DocumentFile ? false : true,
              isMachine: !!item.isMachine,
              isBrochure: !!item.isBrochure,
              IsAccessory: !!item.IsAccessory,
            });
          }
        });
      }

      this.setState({
        exhStallData: exhStallData,
        existingMachinesList: machines,
        isLoadingMachines: false,
      });
    } catch (err) {
      console.error("Error loading exhibitor machines:", err);
      this.setState({ isLoadingMachines: false });
      toastError("Failed to load existing machines for exhibitor.");
    }
  };

  resetMachineForm = () => {
    this.setState({
      editingMachineIndex: -1,
      machineForm: {
        ManufacturerName: "",
        ManufacturingCountry: "",
        isMachine: false,
        IsAccessory: false,
        isBrochure: false,
        MachineDetails: "",
        HSNCode: "",
        Length: "",
        Breadth: "",
        Area: 0,
        Height: "",
        FloorCapacity: "",
        MachineWeight: "",
        DocumentFile: "",
        DocumentName: "",
        DocumentType: "",
        DocumentPath: "",
        DocDeleted: true,
      },
      machineFormErrors: {},
    });
  };

  onMachineFieldChange = (field, value) => {
    this.setState(prevState => {
      const updated = { ...prevState.machineForm, [field]: value };
      const errors = { ...prevState.machineFormErrors, [field]: "" };
      return { machineForm: updated, machineFormErrors: errors };
    });
  };

  onMachineTypeToggle = (type) => {
    this.setState(prevState => {
      const current = prevState.machineForm;
      const updated = {
        ...current,
        [type]: !current[type]
      };
      // If none is a machine, reset dimensions and weights to 0
      if (!updated.isMachine) {
        updated.Length = 0;
        updated.Breadth = 0;
        updated.Area = 0;
        updated.Height = 0;
        updated.FloorCapacity = 0;
        updated.MachineWeight = 0;
      }
      return {
        machineForm: updated,
        machineFormErrors: { ...prevState.machineFormErrors, machineType: "" }
      };
    });
  };

  onMachineDimensionChange = (field, value) => {
    this.setState(prevState => {
      const updated = { ...prevState.machineForm, [field]: value };
      const length = parseFloat(field === 'Length' ? value : updated.Length) || 0;
      const breadth = parseFloat(field === 'Breadth' ? value : updated.Breadth) || 0;
      updated.Area = parseFloat((length * breadth).toFixed(2));
      return { machineForm: updated };
    });
  };

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1200,
        1200,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  onPdfSelect = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  onMachineFilePick = async (e) => {
    e.preventDefault();
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toastError("File size greater than 5MB is not allowed.");
      e.target.value = "";
      return;
    }
    const name = file.name.toLowerCase();
    if (!name.endsWith(".pdf") && !name.endsWith(".jpg") && !name.endsWith(".jpeg") && !name.endsWith(".png")) {
      toastError("Only .pdf, .jpg, .jpeg, .png files are allowed.");
      e.target.value = "";
      return;
    }
    try {
      let fileBase64 = "";
      if (name.endsWith(".pdf")) {
        fileBase64 = await this.onPdfSelect(file);
      } else {
        fileBase64 = await this.resizeFile(file);
      }
      const ext = file.name.split('.').pop();
      this.setState(prevState => ({
        machineForm: {
          ...prevState.machineForm,
          DocumentFile: fileBase64,
          DocumentName: file.name,
          DocumentType: ext,
          DocumentPath: "",
          DocDeleted: false,
        },
        machineFormErrors: { ...prevState.machineFormErrors, DocumentFile: "" }
      }));
    } catch (err) {
      console.error("Error reading file:", err);
      toastError("Error processing selected file.");
    }
  };

  onRemoveMachineDoc = () => {
    this.setState(prevState => ({
      machineForm: {
        ...prevState.machineForm,
        DocumentFile: "",
        DocumentName: "",
        DocumentType: "",
        DocumentPath: "",
        DocDeleted: true,
      }
    }));
  };

  handleEditMachine = (index) => {
    const item = this.state.existingMachinesList[index];
    if (!item) return;
    this.setState({
      editingMachineIndex: index,
      machineForm: {
        ManufacturerName: item.ManufacturerName || "",
        ManufacturingCountry: item.ManufacturingCountry || "",
        isMachine: !!item.isMachine,
        IsAccessory: !!item.IsAccessory,
        isBrochure: !!item.isBrochure,
        MachineDetails: item.MachineDetails || "",
        HSNCode: item.HSNCode || "",
        Length: item.Length || 0,
        Breadth: item.Breadth || 0,
        Area: parseFloat(item.Area) || ((parseFloat(item.Length) || 0) * (parseFloat(item.Breadth) || 0)),
        Height: item.Height || 0,
        FloorCapacity: item.FloorCapacity || 0,
        MachineWeight: item.MachineWeight || 0,
        DocumentFile: item.DocumentFile || "",
        DocumentName: item.DocumentName || "",
        DocumentType: item.DocumentType || "",
        DocumentPath: item.DocumentPath || "",
        DocDeleted: item.DocDeleted !== undefined ? item.DocDeleted : false,
      },
      machineFormErrors: {},
    });
  };

  saveMachinesToApi = async (listToSave) => {
    const { selectedExhibitorOption, ExhibitionID } = this.state;
    if (!selectedExhibitorOption || !selectedExhibitorOption.value) {
      toastError("Please select an exhibitor.");
      return false;
    }

    let currentExhStallData = this.state.exhStallData || {};
    const exbId = parseInt(ExhibitionID || currentExhStallData.ExhibitionID || sessionStorage.getItem("sessionExhibitionID") || 0);
    const exhRegId = parseInt(selectedExhibitorOption.value);

    if (!currentExhStallData.ExhibitionStallSizeID) {
      try {
        const previewRes = await this.props.getPreviewDetails_action(exhRegId, exbId);
        if (previewRes && previewRes.data && previewRes.data[0]) {
          currentExhStallData = previewRes.data[0];
          this.setState({ exhStallData: currentExhStallData });
        }
      } catch (e) {
        console.error(e);
      }
    }

    let primaryChapterList = [];
    let mainPrimary = 0;
    if (currentExhStallData.PrimaryChapter) {
      const parts = String(currentExhStallData.PrimaryChapter).split(',');
      primaryChapterList = parts.map(p => parseInt(p.trim())).filter(p => !isNaN(p));
      if (primaryChapterList.length > 0) {
        mainPrimary = primaryChapterList[0];
      }
    }

    const chapterList = listToSave.map(item => ({
      ExhibitionID: exbId,
      ExhRegistrationID: exhRegId,
      ChapterID: item.ChapterID || 0,
      ChapterName: item.ChapterName || item.MachineDetails || item.ManufacturerName || 'Custom Machine',
      HSNCode: item.HSNCode || '',
      CompanyEmail: item.CompanyEmail || '',
      registrationHQaddress: item.registrationHQaddress || '',
      MachineDetails: item.MachineDetails || '',
      Length: !item.isMachine ? 0 : parseFloat(item.Length) || 0,
      Breadth: !item.isMachine ? 0 : parseFloat(item.Breadth) || 0,
      Area: !item.isMachine ? 0 : (parseFloat(item.Area) || ((parseFloat(item.Length) || 0) * (parseFloat(item.Breadth) || 0))),
      Height: !item.isMachine ? 0 : parseFloat(item.Height) || 0,
      FloorCapacity: !item.isMachine ? 0 : parseFloat(item.FloorCapacity) || 0,
      MachineWeight: !item.isMachine ? 0 : parseFloat(item.MachineWeight) || 0,
      ManufacturerName: item.ManufacturerName || '',
      ManufacturingCountry: item.ManufacturingCountry || '',
      isMachine: !!item.isMachine,
      isBrochure: !!item.isBrochure,
      IsAccessory: !!item.IsAccessory,
      IsSelect: true,
      IsCheckbox: true,
      DocumentFile: item.DocumentFile || '',
      DocumentName: item.DocumentName || '',
      DocumentPath: item.DocumentPath || '',
      DocumentType: item.DocumentType || '',
      DocDeleted: item.DocDeleted !== undefined ? item.DocDeleted : (item.DocumentFile || item.DocumentPath ? false : true),
      SinglePhasePower: item.SinglePhasePower || 0,
      ThreePhasePower: item.ThreePhasePower || 0,
      WaterConsumption: item.WaterConsumption || 0,
      InletQuantity: item.InletQuantity || 0,
      OutletQuantity: item.OutletQuantity || 0,
      BarQuantity: item.BarQuantity || 0,
      CFMQuantity: item.CFMQuantity || 0,
      MaxCompressedAir: item.MaxCompressedAir || 0,
      ShellScheme: item.ShellScheme || null,
      CalculatedArea: item.CalculatedArea || null,
    }));

    try {
      const res = await this.props.primaryChapterAdd_action(
        exbId,
        exhRegId,
        parseInt(currentExhStallData.ExhibitionStallSizeID || 0),
        currentExhStallData.StallArea || 0,
        parseInt(currentExhStallData.StallTypeID || 0),
        parseInt(currentExhStallData.OpenSides || 0),
        chapterList,
        mainPrimary,
        currentExhStallData.isDoubleStorey || false,
        currentExhStallData.DoubleStoreyArea || null,
        currentExhStallData.isSSICertified || false,
        currentExhStallData.TMMA_ITAMMA || null,
        currentExhStallData.ExhRegistrationNo || '',
        currentExhStallData.isSSICertifiedFile || null,
        currentExhStallData.TMMA_ITAMMAFile || null,
        currentExhStallData.isSSICertifiedFiletype || null,
        currentExhStallData.TMMA_ITAMMAfileType || null,
        currentExhStallData.ssiFilepath || '',
        currentExhStallData.TMMA_ITAMMAfilepath || '',
        primaryChapterList,
        currentExhStallData.ExhPrimaryUndertakingPersonName || '',
        currentExhStallData.ExhPrimaryUndertakingMobileNo || '',
        currentExhStallData.ExhPrimaryUndertakingEmail || '',
        currentExhStallData.ExhPrimaryUndertakingDesignation || '',
        currentExhStallData.ExhPrimaryUndertakingCompanyName || '',
        currentExhStallData.ExhPrimaryChapterComment || '',
        currentExhStallData.isMultiPrimaryChapterSelect || false,
        currentExhStallData.InternationalArea || 0,
        currentExhStallData.IsMixRuleAgree || false,
        currentExhStallData.GeneralStallLightingSinglePhasePower || 0,
        currentExhStallData.GeneralStallLightingThreePhasePower || 0
      );

      if (res && res.error != 1) {
        await this.loadExhibitorMachines(exhRegId, exbId);
        return true;
      } else {
        toastError(res?.msg || "Failed to save machine.");
        return false;
      }
    } catch (err) {
      console.error("Error saving machine:", err);
      toastError("An error occurred while saving machine.");
      return false;
    }
  };

  handleDeleteMachine = async (index) => {
    const list = [...this.state.existingMachinesList];
    list.splice(index, 1);
    this.setState({ isSavingMachine: true });
    const success = await this.saveMachinesToApi(list);
    this.setState({ isSavingMachine: false });
    if (success) {
      toastSuccess("Machine deleted successfully.");
      if (this.state.editingMachineIndex === index) {
        this.resetMachineForm();
      }
    }
  };

  handleAddOrUpdateMachineInList = async () => {
    const { machineForm, existingMachinesList, selectedExhibitorOption } = this.state;
    if (!selectedExhibitorOption || !selectedExhibitorOption.value) {
      toastError("Please select an exhibitor first.");
      return;
    }

    const errors = {};

    if (!machineForm.ManufacturerName || !machineForm.ManufacturerName.trim()) {
      errors.ManufacturerName = "Company Name is required.";
    }
    if (!machineForm.ManufacturingCountry || !machineForm.ManufacturingCountry.trim()) {
      errors.ManufacturingCountry = "Country of Origin is required.";
    }
    if (!machineForm.isMachine && !machineForm.IsAccessory && !machineForm.isBrochure) {
      errors.machineType = "Please select at least one: Machine, Product, or Only Brochure.";
    }

    if (machineForm.isMachine) {
      if (parseFloat(machineForm.Length) <= 0 || !machineForm.Length) {
        errors.Length = "Length is required.";
      }
      if (parseFloat(machineForm.Breadth) <= 0 || !machineForm.Breadth) {
        errors.Breadth = "Breadth is required.";
      }
      if (parseFloat(machineForm.Height) <= 0 || !machineForm.Height) {
        errors.Height = "Height is required.";
      }
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ machineFormErrors: errors });
      toastError("Please fill all required machine details.");
      return;
    }

    const machineItem = {
      ChapterID: 0,
      ChapterName: machineForm.MachineDetails || machineForm.ManufacturerName || "Custom Machine",
      ManufacturerName: machineForm.ManufacturerName.trim(),
      ManufacturingCountry: machineForm.ManufacturingCountry.trim(),
      isMachine: !!machineForm.isMachine,
      IsAccessory: !!machineForm.IsAccessory,
      isBrochure: !!machineForm.isBrochure,
      MachineDetails: machineForm.MachineDetails || "",
      HSNCode: machineForm.HSNCode || "",
      Length: !machineForm.isMachine ? 0 : parseFloat(machineForm.Length) || 0,
      Breadth: !machineForm.isMachine ? 0 : parseFloat(machineForm.Breadth) || 0,
      Area: !machineForm.isMachine ? 0 : parseFloat(machineForm.Area) || 0,
      Height: !machineForm.isMachine ? 0 : parseFloat(machineForm.Height) || 0,
      FloorCapacity: !machineForm.isMachine ? 0 : parseFloat(machineForm.FloorCapacity) || 0,
      MachineWeight: !machineForm.isMachine ? 0 : parseFloat(machineForm.MachineWeight) || 0,
      DocumentFile: machineForm.DocumentFile || "",
      DocumentName: machineForm.DocumentName || "",
      DocumentType: machineForm.DocumentType || "",
      DocumentPath: machineForm.DocumentPath || "",
      DocDeleted: machineForm.DocDeleted !== undefined ? machineForm.DocDeleted : (machineForm.DocumentFile || machineForm.DocumentPath ? false : true),
      IsSelect: true,
      IsCheckbox: true,
      CompanyEmail: "",
      registrationHQaddress: "",
      SinglePhasePower: 0,
      ThreePhasePower: 0,
      WaterConsumption: 0,
      InletQuantity: 0,
      OutletQuantity: 0,
      BarQuantity: 0,
      CFMQuantity: 0,
      MaxCompressedAir: 0,
      ShellScheme: null,
      CalculatedArea: null,
    };

    const validExisting = (existingMachinesList || []).filter(
      item => item.isMachine || item.IsAccessory || item.isBrochure || (item.ManufacturerName && item.ManufacturerName.trim())
    );
    const updatedList = [...validExisting, machineItem];

    this.setState({ isSavingMachine: true });
    const success = await this.saveMachinesToApi(updatedList);
    this.setState({ isSavingMachine: false });

    if (success) {
      toastSuccess("Machine added successfully!");
      this.resetMachineForm();
    }
  };

  handleExhibitionDropdownChange = async (newExhibitionID) => {
    this.setState({ ExhibitionID: newExhibitionID, selectedExhibitorOption: null });
    await this.getFillList(exhibitorNameActionId, newExhibitionID, "", "", "", "");
  };

  // get fill List dropdown  
  async getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
    try {
      const data = await this.props.fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
      if (data && data.error != 1) {
        if (actionID === exhibitionId) {
          await new Promise(resolve => this.setState({ exhibitionList: data.data || [] }, resolve))
        }
        if (actionID === serviceTypeId) {
          console.log("voucher type data", data.data)
          await new Promise(resolve => this.setState({ serviceTypeList: data.data || [] }, resolve))
        }
        if (actionID === orderStatusActionId) {
          await new Promise(resolve => this.setState({ orderStatusList: data.data || [] }, resolve))
        }
        if (actionID === countryActionId) {
          await new Promise(resolve => this.setState({ countryList: data.data || [] }, resolve));
        }
        if (actionID === exhibitorNameActionId) {
          const array = [];
          data.data && data.data.forEach((item) => {
            array.push({
              value: item.ExhRegistrationID,
              label: item.ExhRegistrationNo
                ? `${item.CompanyName} (${item.ExhRegistrationNo})`
                : item.CompanyName,
              item: item
            });
          });
          const savedExhId = sessionStorage.getItem("ExhRegistrationIDSS");
          const currentSelected = savedExhId ? array.find(o => String(o.value) === String(savedExhId)) : null;
          this.setState({
            exhibitorDropdownList: array,
            selectedExhibitorOption: currentSelected || this.state.selectedExhibitorOption || null
          });
        }
      } else if (data?.msg) {
        toastError(data.msg)
      }
    } catch (e) {
      console.log(e);
    }
  }




  // Update Current Page
  updateItem(item) {
    const { vendorRegistrationList } = this.state
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    const currentRecords = vendorRegistrationList.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(vendorRegistrationList.length / recordsPerPage)
  }

  // isSilent = background poll: keep the loader hidden and don't toast transient errors
  async getVendorExhibitionList(isSilent = false) {
    const { ExhibitionID, ServiceID, StatusID } = this.state
    const filterStatusID = sessionStorage.getItem('filterStatusID')
    if (!isSilent) {
      this.startLoading()
    }
    try {
      const data = await this.props.getVendorExhibitionList_action(ExhibitionID, ServiceID, StatusID)
      if (data && data.error != 1) {
        if (!isSilent) console.log('API Response data.data:', data.data);
        await new Promise((resolve) => {
          this.setState({
            vendorRegistrationList: data.data?.exhibitorList || [],
            vendorServiceList: data.data?.serviceList || [],
            dashboardData: data.data
          }, () => {
            if (!isSilent) console.log('Updated dashboardData:', this.state.dashboardData);
            resolve()
          })
        })

        if (filterStatusID === '3' && data.data?.exhibitorList?.length > 0) {
          const exhibitionID = sessionStorage.getItem('sessionExhibitionID')
          const vendorID = sessionStorage.getItem('AccountIDSS')
          const orderDetails = data.data.exhibitorList.map(item => ({
            ExhibitionID: exhibitionID,
            VendorID: vendorID,
            ExhRegistrationID: item.ExhRegistrationID,
            ServiceID: item.ServiceID
          }))
          await this.props.markOrderSeen_action(orderDetails)
        }
      } else {
        if (!isSilent && data?.msg) toastError(data.msg)
      }
    } catch (err) {
      console.log(err)
    } finally {
      if (!isSilent) {
        this.stopLoading()
      }
    }
  }

  exportData = () => {
    const { vendorRegistrationList } = this.state;
    if (!vendorRegistrationList || vendorRegistrationList.length === 0) {
      toastError("No data to export");
      return;
    }

    const exportRows = vendorRegistrationList.map((item) => ({
      "Hall": item.Hall || "-",
      "Zone": item.Zone || "-",
      "Stall": item.Stall || "-",
      "Exhibitor Registration No": item.ExhRegistrationNo || "-",
      "Company Name": item.CompanyName || "-",
      "Contact Person": item.name || "-",
      "Service": item.serviceprovided || "-",
      "GST No": item.GSTNo || "-",
      "Status": item.Status || "-",
    }));

    const ws = XLSX.utils.json_to_sheet(exportRows);
    ws["!cols"] = [
      { wch: 15 }, // Hall
      { wch: 15 }, // Zone
      { wch: 15 }, // Stall
      { wch: 30 }, // Exhibitor Registration No
      { wch: 40 }, // Company Name
      { wch: 28 }, // Contact Person
      { wch: 20 }, // Service
      { wch: 22 }, // GST No
      { wch: 18 }, // Status
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Exhibition List");
    XLSX.writeFile(wb, "Order_List.xlsx");
  };

  async clearValue() {
    const loginData = JSON.parse(sessionStorage.getItem('loginDataSS'));
    this.startLoading();
    try {
      if (loginData && (loginData.RoleID === 7 || loginData.RoleID === 17)) {
        // For vendors, don't clear ExhibitionID, only ServiceID and StatusID
        await new Promise(resolve => this.setState({ ServiceID: '', StatusID: '' }, resolve));
      } else {
        await new Promise(resolve => this.setState({ ExhibitionID: '', ServiceID: '', StatusID: '' }, resolve));
      }
      await this.getVendorExhibitionList();
    } catch (err) {
      console.log('Error in clearValue:', err);
    } finally {
      this.stopLoading();
    }
  }

  onViewClick(exhRegId, ServiceID) {
    const { CompanyName } = this.state
    sessionStorage.setItem("ExhRegistrationIDSS", exhRegId)
    if (ServiceID == 3) {
      this.props.navigate('/powerConnection', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 4) {
      this.props.navigate('/water', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 5) {
      this.props.navigate('/airConnectionApplication', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 6) {
      this.props.navigate('/meetingRoomRequestForm', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 9) {
      this.props.navigate('/exhibitorbadgeAU', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 10) {
      this.props.navigate('/stallDesign', { state: { is_View: true, from: 'vendor' } })
    }
    else if (ServiceID == 21) {
      this.props.navigate('/freightForward', { state: { is_View: true, from: 'vendor' } })
    }
  }

  openRaiseModal = (record) => {
    const documentFile = record.InvoiceDocument
      ? { FileName: record.InvoiceDocument.split('/').pop(), FilePath: `${DOC_BASE_URL}${record.InvoiceDocument}`, FileType: '' }
      : { FileName: '', FilePath: '', FileType: '' };

    this.setState({
      showRaiseModal: true,
      selectedRecord: record,
      selectedFile: null,
      useCamera: false,
      documentFile
    })
  }

  openMarkPaidModal = (record) => {
    this.setState({ showMarkPaidModal: true, selectedRecord: record })
  }

  closeModals = () => {
    this.setState({
      showRaiseModal: false,
      showMarkPaidModal: false,
      selectedRecord: null,
      selectedFile: null,
      useCamera: false,
      documentFile: { FileName: '', FilePath: '', FileType: '' },
      showCameraModal: false
    })
  }

  handleFileSelect = (e) => {
    this.setState({ selectedFile: e.target.files[0] })
  }

  async handleDocumentInput(e, fieldName) {
    if (fieldName === 'file') {
      const result = await this.onFilePick(e, e.target.files)
      if (result) {
        this.setState({
          documentFile: {
            FilePath: result.FilePath,
            FileName: result.FileName,
            FileType: result.FileType
          }
        })
      }
    } else if (fieldName === 'clear') {
      this.setState({
        documentFile: { FileName: '', FilePath: '', FileType: '' }
      })
    }
  }

  onFilePick = async (e, file) => {
    e.preventDefault()
    var image = '';
    if (file[0]['size'] > 3145728) {
      toast.error('File size more than 3MB are not allow.', {
        position: "top-center",
        theme: 'colored',
        autoClose: 3000,
        hideProgressBar: true,
      })
      return null;
    } else {
      if (file[0]['name'].toString().toLowerCase().includes('.pdf')
        ||
        file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
        file[0]['name'].toString().toLowerCase().includes('.png') ||
        file[0]['name'].toString().toLowerCase().includes('.jpg')
      ) {
        if (file[0]['name'].includes('pdf')) {
          image = await this.onPdfSelect(file[0]);
        }
        else {
          image = await this.resizeFile(file[0]);
        }

        const fileType = file[0]['type']
        var fileTypeList;
        if (fileType.includes("/")) {
          fileTypeList = fileType.split("/")
        }
        const finalFileTypeName = fileTypeList.length > 0 ? fileTypeList[1] : ''

        return { FilePath: image, FileName: file[0]['name'], FileType: finalFileTypeName }

      } else {
        toast.error('Only .pdf, .jpeg, .png, files are allowed', {
          position: "top-center",
          theme: 'colored',
          autoClose: 3000,
          hideProgressBar: true,
        })
        return null;
      }
    }
  }

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      let fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        resolve(base64);
      };
      fileReader.readAsDataURL(file);
    });

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });



  handleViewFile = (filePathOrBase64, fileName) => {
    // Check if it's a base64 string or a URL
    if (filePathOrBase64.startsWith('data:')) {
      // Handle base64 string
      const mimeType = filePathOrBase64.split(';')[0].split(':')[1];
      const byteCharacters = atob(filePathOrBase64.split(',')[1]);
      const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const fileURL = URL.createObjectURL(blob);

      if (mimeType.startsWith('image/') || mimeType === 'application/pdf') {
        window.open(fileURL, '_blank', 'noopener,noreferrer');
      } else {
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = fileName;
        link.click();
      }
      setTimeout(() => URL.revokeObjectURL(fileURL), 500);
    } else {
      // Handle regular URL
      window.open(filePathOrBase64, '_blank', 'noopener,noreferrer');
    }
  };

  handleCameraCapture = async (base64Image) => {
    this.setState({
      documentFile: {
        FilePath: base64Image,
        FileName: 'camera-capture.jpg',
        FileType: 'jpeg'
      },
      showCameraModal: false,
      showRaiseModal: true
    })
  }

  handleRaiseManualForm = async () => {
    const { selectedRecord, documentFile } = this.state

    if (!documentFile.FilePath || documentFile.FilePath.trim() === '') {
      toastError('Please upload a file')
      return
    }

    const documentData = [{
      DocumentName: documentFile.FileName,
      FileName: documentFile.FileName,
      FilePath: documentFile.FilePath,
      FileType: documentFile.FileType,
      ActionID: 1
    }]

    this.startLoading()
    try {
      const data = await this.props.raiseManualForm_action(selectedRecord.ManualFormID, selectedRecord.RecordID, documentData)
      if (data && data.error != 1) {
        toastSuccess('Manual form raised successfully!')
        this.closeModals()
        await this.getVendorExhibitionList()
      } else {
        toastError(data?.msg || 'Failed to raise manual form')
      }
    } catch (err) {
      toastError('Something went wrong!')
    } finally {
      this.stopLoading()
    }
  }

  handleMarkPaid = async () => {
    const { selectedRecord } = this.state
    const isPaid = selectedRecord?.IsInvoicePaid === true || selectedRecord?.IsInvoicePaid === 1
    const newPaidStatus = !isPaid

    this.startLoading()
    try {
      const data = await this.props.markManualFormInvoicePaid_action(selectedRecord.ManualFormID, selectedRecord.RecordID, newPaidStatus)
      if (data && data.error != 1) {
        toastSuccess(newPaidStatus ? 'Manual form marked as paid successfully!' : 'Manual form unmarked as paid successfully!')
        this.closeModals()
        await this.getVendorExhibitionList()
      } else {
        toastError(data?.msg || 'Failed to update payment status')
      }
    } catch (err) {
      toastError('Something went wrong!')
    } finally {
      this.stopLoading()
    }
  }

  // Single source of truth for the Action column - both the column header and the row icons are
  // built from this list, so adding an action here is enough to get it into the header as well
  getRowActions() {
    const isRoleID20 = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 20
    const canRaiseBill = (data) => !isRoleID20 && data.isITMEBilling === false && data.optionForBillRaised === true

    return [
      {
        label: "View Details",
        iconClass: "fa fa-eye grid-icon",
        color: "#6c757d",
        isVisible: (data) => true,
        onClick: (data) => this.handleCompanyModal(data),
      },
      {
        label: "Upload Invoice",
        iconClass: "fa fa-file-text grid-icon",
        color: "#6c757d",
        isVisible: canRaiseBill,
        onClick: (data) => this.openRaiseModal(data),
      },
      {
        label: "Mark Invoice Paid",
        iconClass: "fa fa-check-circle",
        color: "#28a745",
        isVisible: canRaiseBill,
        onClick: (data) => this.openMarkPaidModal(data),
      },
    ]
  }

  render() {
    const { isLoading, ExhibitionID, CompanyName, vendorServiceList, PersonName, ServiceID, currentPage, vendorRegistrationList, exhibitionList, serviceTypeList, orderStatusList, dashboardData } = this.state

    const serviceList = dashboardData?.serviceList || [];
    const hasOnlyService32 = serviceList.length === 1 && serviceList[0]?.ServiceID === 32;

    console.log('serviceList:', serviceList, 'hasOnlyService32:', hasOnlyService32);

    if (hasOnlyService32) {
      return (
        <>
          {isLoading ? <Loader></Loader> : null}
          <ToastContainer />
          {JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
            <ExhibitorHeader /> : <HeaderWithLogo />
          }
          <div className="main-content p-3 pt-2 vendor-top-space">
            {JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
              <ExhibitorDrawer /> :
              JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17 ?
                <VendorDrawer /> : <AdminDrawer />
            }
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
              <div className="text-center">
                <h4>This page is not applicable for you</h4>
              </div>
            </div>
          </div>
        </>
      );
    }

    // console.log(vendorServiceList)
    var vendorServiceListArr = []
    vendorServiceList.length > 0 && vendorServiceList.forEach(item => {
      for (var i = 0; i < serviceTypeList.length; i++) {
        if (serviceTypeList[i].ServiceID == item.ServiceID) {
          vendorServiceListArr.push(serviceTypeList[i])
          break
        }
      }
    })
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    const currentRecords = vendorRegistrationList.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(vendorRegistrationList.length / recordsPerPage)

    // Action column header is built from the tooltips of the action icons this user can actually see
    const rowActions = this.getRowActions()
    const visibleActions = rowActions.filter((action) =>
      currentRecords.some((data) => action.isVisible(data))
    )
    const actionHeader = visibleActions.length > 0
      ? visibleActions.map((action) => action.label).join("/")
      : "Action"

    console.log("currentRecords", currentRecords)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID === 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) &&
          this.state.showVideoModal && (
            <div
              className="modal show d-block"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={() => this.setState({ showVideoModal: false })}
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Order</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => this.setState({ showVideoModal: false })}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <video controls autoPlay style={{ width: "100%" }}>
                      <source src="/assets/VendorOrder.mp4" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        <div className={"main-content p-3 pt-2 vendor-top-space"}>
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 20 &&
            <>
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                <ExhibitorDrawer />
              ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17 ? (
                <VendorDrawer />
              ) : (
                <AdminDrawer />
              )}
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                <ExhibitorTopMenu />
              ) : null}

            </>
          }
          {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) && (
            <div className="d-flex justify-content-end px-2 pt-3 text-aqua">
              {/* <span
                onClick={() => this.setState({ showVideoModal: true })}
                style={{
                  cursor: "pointer",
                  color: "#3dbca7",
                  fontSize: "16px",
                  marginLeft: "auto",
                }}
              >
                <i className="bi bi-play-circle-fill me-2"></i>User Manual
              </span> */}
            </div>
          )}
          {/* <div class="row">
                        <div class="step-name">
                            <p>Service Partner Registration List</p>
                        </div>
                    </div> */}


          <div className="row align-items-end">
            <div className="col-xl-2 col-lg-3 col-md-6 mb-3">
              <label>Exhibition</label>
              <select
                className="form-control"
                id="roledb"
                value={ExhibitionID}
                onChange={(e) => this.handleExhibitionDropdownChange(e.target.value)}
                disabled={JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID === 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17}
              >
                <option>Select</option>
                {exhibitionList.length > 0 &&
                  exhibitionList.map((data) => (
                    <option key={data.ExhibitionID} value={data.ExhibitionID}>
                      {data.ExhibitionName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 mb-3">
              <label>Service Type</label>
              <select
                className="form-control"
                id="roledb"
                // style={{ textAlign: "left" }}
                value={ServiceID}
                onChange={(e) => this.setState({ ServiceID: e.target.value })}
              >
                <option>Select</option>
                {vendorServiceListArr.length > 0 &&
                  vendorServiceListArr.map((data) => (
                    <option key={data.ServiceID} value={data.ServiceID}>
                      {data.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 mb-3">
              <label>Status</label>
              <select
                className="form-control"
                id="roledb"
                value={this.state.StatusID}
                onChange={(e) => this.setState({ StatusID: e.target.value })}
              >
                <option>Select</option>
                {orderStatusList.length > 0 &&
                  orderStatusList.map((data) => (
                    <option key={data.Code} value={data.Code}>
                      {data.Description}
                    </option>
                  ))}
              </select>
            </div>

            {/* <div className="row mt-3"> */}
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3 d-flex justify-content-start">
              <div
                className=" mb-1"
                role="group"
                aria-label="Basic example"
                style={{ float: "left" }}
              >
                {/* <button
                  type="button"
                  className="btn btn-aqua"
                  onClick={(e) => this.exportData()}
                >
                  Export
                </button> */}
                <button
                  type="button"
                  className="btn btn-aqua mx-2"
                  onClick={(e) => this.getVendorExhibitionList()}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={(e) => this.clearValue()}
                >
                  Clear
                </button>
                {/* <button
                  type="button"
                  className="btn btn-aqua mx-2"
                  onClick={(e) => this.exportData()}
                >
                  Export
                </button> */}
              </div>
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 20
                && <>
                  {currentRecords.some(
                    (data) => data.isITMEBilling === false && data.optionForBillRaised === true
                  ) && (
                      <div className="d-flex flex-column ms-3" style={{ fontSize: "13px" }}>
                        <span className="mb-1">
                          <i
                            className="fa fa-file-text"
                            style={{ color: "#6c757d", marginRight: "5px" }}
                          ></i>
                          <span className="me-1">Upload Invoice</span>
                          <i
                            className="fa fa-info-circle"
                            style={{ color: "#6c757d", cursor: "pointer" }}
                            title="Upload invoice document directly to exhibitor"
                          ></i>
                        </span>
                        <span>
                          <i
                            className="fa fa-check-circle"
                            style={{ color: "#28a745", marginRight: "5px" }}
                          ></i>
                          <span className="me-1">Mark Payment</span>
                          <i
                            className="fa fa-info-circle"
                            style={{ color: "#6c757d", cursor: "pointer" }}
                            title="Mark the invoice as paid after payment confirmation"
                          ></i>
                        </span>
                      </div>
                    )}
                </>
              }
            </div>
            {/* </div> */}
            {sessionStorage.getItem("isFreightForwardVendor") == 'true' &&
              <div className="col-xl-3 col-lg-3 col-md-6 mb-3 d-flex justify-content-start">

                {/* Action Buttons for Freight Forward Form and Add Machines */}
                <div className="gap-2">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    style={{ minHeight: '38px' }}
                    onClick={this.handleOpenFreightForward}
                  >
                    <i className="fa fa-truck me-1"></i> +Freight Forward
                  </button>
                  <button
                    type="button"
                    className="btn btn-aqua mx-2"
                    style={{ minHeight: '38px' }}
                    onClick={this.handleOpenAddMachineModal}
                  >
                    <i className="fa fa-cogs me-1"></i> +Add Machines
                  </button>
                </div>
              </div>
            }
          </div>

          <div
            className="table-responsive sticky-table-wrapper mb-2 px-0"
            style={{ maxHeight: "calc(100vh - 290px)", overflowY: "auto" }}
          >
            <table className="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
              <thead className="table-light">
                <tr>
                  {/* Hall */}
                  <th className="text-center">
                    <div className="th-header-with-sort">
                      <span>Hall</span>
                      {/* <div className="icons-shorting"
                          onClick={() => this.handleSort("Hall")}
                        >
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Zone */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Zone</span>
                      {/* <div className="icons-shorting"
                          onClick={() => this.handleSort("Zone")}
                        >
                          <i className="" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Stall */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Stall</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Stall")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Exhibitor */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Exhibitor</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Exhibitor")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>
                  <th>
                    <div className="th-header-with-sort">
                      <span>Form Submit Date</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Exhibitor")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Service */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Service</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Service")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  <th>
                    <div className="th-header-with-sort">
                      <span>Country</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("ScheduledDate")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>
                  <th>
                    <div className="th-header-with-sort">
                      <span>GST No</span>
                    </div>
                  </th>
                  {/* <th>
                    <div className="th-header-with-sort">
                      <span>PAN No</span>
                    </div>
                  </th> */}
                  <th>{false ? "Work Status" : "Status"}</th>

                  <th style={{ width: '100px', textAlign: 'center' }}>
                    <div className="th-header-with-sort justify-content-center">
                      <span>{actionHeader}</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("ScheduledDate")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Status / Work Status */}
                </tr>
              </thead>
              <tbody>
                {currentRecords?.length > 0 ? (
                  (currentRecords
                  ).map((item, i) =>
                    <tr>
                      <td className="text-left hall-name">{item.Hall}</td>
                      <td>{item.Zone}</td>
                      <td>{item.Stall}</td>
                      <td>
                        <div className="text-nowrap">
                          <div style={{ fontWeight: 650, marginBottom: '6px' }}>{item.ExhRegistrationNo}</div>

                          <div className="d-flex align-items-center gap-3">
                            <span>
                              <i className="fa fa-building-o grid-icon me-1"></i>
                              <span className="text-aqua"
                                onClick={(e) => this.handleCompanyModal(item)}
                                style={{ cursor: "pointer" }}>
                                {item.CompanyName != null ? item.CompanyName : "-"}
                              </span>
                            </span>

                            <span>
                              <i className="ri-user-3-line grid-icon me-1"></i>
                              {item.name != null ? item.name : "-"}
                            </span>

                            <span>
                              <i className="ri-mail-line grid-icon me-1"></i>
                              {item.Email}
                            </span>
                          </div>
                        </div>
                      </td>
                      {/* <td>/td> */}
                      <td>
                        {item.ExhRegistrationDate != null
                          ? moment(item.ExhRegistrationDate).format("DD/MM/YYYY")
                          : "-"}
                      </td>
                      <td>
                        {item.serviceprovided || "-"}{" "}
                        {item.serviceprovided != 'NA' &&
                          <span
                            style={{ cursor: "pointer", fontSize: "18px", paddingTop: "30px" }}
                            onClick={() =>
                              this.handleManualFormModal(item.serviceprovided, item.ExhRegistrationID)
                            }
                          >
                            <i
                              className="bi bi-info-circle grid-icon"
                              style={{ cursor: "pointer" }}
                            ></i>
                          </span>
                        }
                      </td>
                      <td>{item.CountryName}</td>
                      <td>{item.GSTNo}</td>
                      {/* <td>{item.PanNo}</td> */}
                      <td>
                        <span
                          // style={{
                          //   color: !item.WorkStatusID ? "" : "",
                          // }}
                          className={item.WorkStatusID ? "status text-aqua" : "status grid-icon"}
                        >
                          {item.Status}
                        </span>
                      </td>
                      <td className="text-center">
                        <i
                          className="fa fa-eye grid-icon"
                          aria-hidden="true"
                          style={{
                            marginRight: "12px",
                            cursor: "pointer",
                            color: "#6c757d",
                          }}
                          title="View Details"
                          onClick={() => this.handleCompanyModal(item)}
                        />
                        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 20 && item.isITMEBilling === false && item.optionForBillRaised === true && (
                          <>
                            <i
                              className="fa fa-file-text grid-icon"
                              aria-hidden="true"
                              style={{
                                marginRight: "12px",
                                cursor: "pointer",
                                color: "#6c757d",
                              }}
                              title={item.InvoiceDocument ? "Upload/Change Invoice" : "Upload Invoice"}
                              onClick={() => this.openRaiseModal(item)}
                            />
                            {!(item.IsInvoicePaid === true || item.IsInvoicePaid === 1) && (
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                                style={{ cursor: "pointer", color: "#28a745" }}
                                title="Mark Invoice Paid"
                                onClick={() => this.openMarkPaidModal(item)}
                              />
                            )}
                            {(item.IsInvoicePaid === true || item.IsInvoicePaid === 1) && (
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                                style={{ cursor: "pointer", color: "#28a745", opacity: 0.5 }}
                                title="Invoice Marked as Paid"
                              />
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                  )
                ) : (
                  <tr>
                    <td colSpan={20} className="text-center">
                      Record not found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="mt-2 mb-2 float-left trp">
            {vendorRegistrationList.length > 0 ? (
              <Pagination
                nPages={nPages}
                currentPage={currentPage}
                setCurrentPage={this.updateItem}
              />
            ) : (
              <></>
            )}
            <div className="table-record-pages">
              <p>{`${currentPage} of ${nPages} pages`}</p>
            </div>
          </div>
        </div>

        {/* Raise Manual Form Modal */}
        {this.state.showRaiseModal &&
          createPortal(
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 9999 }}
              onClick={this.closeModals}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Upload Invoice</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={this.closeModals}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {this.state.selectedRecord?.InvoiceDocument && (this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1) ? (
                      <div className="mb-3">
                        <div className="d-flex align-items-center">
                          <span
                            className="grid-icon me-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.handleViewFile(
                                this.state.documentFile.FilePath,
                                this.state.documentFile.FileName
                              )
                            }
                          >
                            <i className="fa fa-eye me-1"></i>
                            {this.state.documentFile.FileName}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="mb-3">
                        {this.state.documentFile.FilePath ? (
                          <div className="d-flex align-items-center">
                            <span
                              className="grid-icon me-2"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.handleViewFile(
                                  this.state.documentFile.FilePath,
                                  this.state.documentFile.FileName
                                )
                              }
                            >
                              <i className="fa fa-eye me-1"></i>
                              {this.state.documentFile.FileName}
                            </span>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => this.handleDocumentInput(null, "clear")}
                            >
                              <i className="fa fa-times"></i> Remove
                            </button>
                          </div>
                        ) : (
                          <>
                            <label className="form-label">Upload Invoice Document</label>
                            <input
                              type="file"
                              className="form-control mb-2"
                              accept="image/*,application/pdf"
                              onChange={(e) => this.handleDocumentInput(e, "file")}
                            />
                            <div className="text-center">
                              <span className="text-muted">OR</span>
                            </div>
                            <button
                              type="button"
                              className="btn btn-aqua w-100 mt-2"
                              onClick={() =>
                                this.setState({ showCameraModal: true, showRaiseModal: false })
                              }
                            >
                              <i className="fa fa-camera me-2"></i>
                              Capture from Camera
                            </button>
                          </>
                        )}
                      </div>
                    )}

                    <div className="alert alert-warning d-flex align-items-center py-2 mb-2">
                      <i className="fa fa-exclamation-triangle me-2"></i>
                      <small>
                        All transactions will be between you and the exhibitor only. The
                        organizer is not involved.
                      </small>
                    </div>
                    <div className="text-center">
                      <small className="text-muted">
                        Supported formats: PDF, JPEG, PNG, JPG (Max size: 5MB)
                      </small>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-gray" onClick={this.closeModals}>
                      Back
                    </button>
                    {!(this.state.selectedRecord?.InvoiceDocument && (this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1)) && (
                      <button
                        type="button"
                        className="btn btn-aqua"
                        onClick={this.handleRaiseManualForm}
                      >
                        Yes, Upload direct to exhibitor
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>,
            document.body
          )}

        {/* Camera Capture Modal */}
        <ImageCapture
          isOpen={this.state.showCameraModal}
          onClose={() => this.setState({ showCameraModal: false, showRaiseModal: true })}
          onCapture={this.handleCameraCapture}
          label="Capture Invoice Document"
        />

        {/* Mark Manual Form Invoice Paid Modal */}
        {this.state.showMarkPaidModal &&
          createPortal(
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 9999 }}
              onClick={this.closeModals}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title text-aqua">
                      {this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1
                        ? 'Confirm Unmark Payment'
                        : 'Confirm Payment'}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={this.closeModals}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      {this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1
                        ? 'Are you sure you want to unmark this manual form invoice as paid?'
                        : 'Are you sure you want to mark this manual form invoice as paid?'}
                    </p>
                    {this.state.selectedRecord && (
                      <div className="">
                        <strong>Company:</strong> {this.state.selectedRecord.CompanyName}
                        <br />
                        <strong>Service:</strong> {this.state.selectedRecord.serviceprovidedDisplayName}
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-gray"
                      onClick={this.closeModals}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleMarkPaid}
                    >
                      {this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1
                        ? 'Yes, Unmark as Paid'
                        : 'Yes, Mark as Paid'}
                    </button>
                  </div>
                </div>
              </div>
            </div>,
            document.body
          )}
        <Modal
          isOpen={this.state.isManualFormModalOpen}
          onRequestClose={this.handleCloseFreightForward}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog  modal-almost-fullscreen modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header text-white">
                <h6 className="modal-title">Manual Form - {this.state.selectedServiceName || ""}</h6>
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={this.handleCloseFreightForward}
                  />
                </div>
              </div>

              {this.state.isFreightForwardAddMode && (
                <div className="p-3 bg-light border-bottom">
                  <div className="row align-items-center">
                    <div className="col-md-7">
                      <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#137976' }}>
                        <i className="fa fa-user me-1"></i> Select Exhibitor: <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={this.state.exhibitorDropdownList || []}
                        value={this.state.selectedExhibitorOption}
                        onChange={this.handleExhibitorChange}
                        placeholder="Search and select exhibitor by name or reg no..."
                        isSearchable={true}
                        isClearable={true}
                        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 99999 }),
                          control: (base) => ({ ...base, minHeight: '38px', fontSize: '13px' }),
                          option: (base) => ({ ...base, fontSize: '13px' })
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="modal-body" style={{ maxHeight: "calc(85vh - 120px)", overflowY: "auto" }}>
                {this.state.isFreightForwardAddMode && !this.state.selectedExhibitorOption?.value ? (
                  <div className="text-center py-5 text-muted">
                    <i className="fa fa-truck fa-3x mb-2 text-secondary"></i>
                    <p className="mb-0 text-center">Please select an exhibitor from the dropdown above to load and submit their on-site Freight Forward form.</p>
                  </div>
                ) : (
                  this.openModal(this.state.selectedServiceName)
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={this.handleCloseFreightForward}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.isCompanyModalOpen}
          onRequestClose={this.handleCloseCompanyModal}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header text-white">
                <h6 className="modal-title">Order Details</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={this.handleCloseCompanyModal}
                />
              </div>

              <div className="modal-body">
                {this.state.selectedCompanyData && this.openModal(this.state.selectedCompanyData.serviceprovided)}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={this.handleCloseCompanyModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Modal: Add Machines Against Exhibitor (Blue-Ticked Fields Only) */}
        <Modal
          isOpen={this.state.isAddMachineModalOpen}
          onRequestClose={this.handleCloseAddMachineModal}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: '95vw' }}>
            <div className="modal-content" style={{ minHeight: '520px' }}>
              <div className="modal-header text-white" style={{ background: '#137976' }}>
                <h5 className="modal-title mb-0">
                  <i className="fa fa-cogs me-2"></i>
                  + Add Machines
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={this.handleCloseAddMachineModal}
                />
              </div>

              {/* Select Exhibitor Dropdown: Placed outside modal-body so it stays fixed and never scrolls */}
              <div className="p-3 bg-light border-bottom">
                <div className="row align-items-center">
                  <div className="col-md-7">
                    <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#137976' }}>
                      <i className="fa fa-user me-1"></i> Select Exhibitor <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={this.state.exhibitorDropdownList || []}
                      value={this.state.selectedExhibitorOption}
                      onChange={async (opt) => {
                        this.handleExhibitorChange(opt);
                        if (opt && opt.value) {
                          this.setState({ isLoadingMachines: true });
                          await this.loadExhibitorMachines(opt.value, this.state.ExhibitionID);
                        } else {
                          this.setState({ existingMachinesList: [], exhStallData: {} });
                        }
                      }}
                      placeholder="Search and select exhibitor by name or reg no..."
                      isSearchable={true}
                      isClearable={true}
                      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 99999 }),
                        control: (base) => ({ ...base, minHeight: '38px', fontSize: '13px' }),
                        option: (base) => ({ ...base, fontSize: '13px' })
                      }}
                    />
                  </div>
                  {this.state.selectedExhibitorOption && (
                    <div className="col-md-5 text-muted" style={{ fontSize: '16px', marginTop: '33px' }}>
                      {this.state.exhStallData?.StallArea ? (
                        <span>
                          <strong>Stall Area:</strong> {this.state.exhStallData.StallArea} Sqm | <strong>Type:</strong> {this.state.exhStallData.StallTypeID == 2 ? 'Shell' : 'Bare'} | <strong>Open Sides:</strong> {this.state.exhStallData.OpenSides || 'N/A'}
                        </span>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-body p-3" style={{ minHeight: '320px', maxHeight: "calc(88vh - 160px)", overflowY: "auto" }}>
                {!this.state.selectedExhibitorOption?.value ? (
                  <div className="text-center py-5 text-muted">
                    <i className="fa fa-cogs fa-3x mb-2 text-secondary"></i>
                    <p className="mb-0 text-center">Please select an exhibitor from the dropdown above to manage their machines.</p>
                  </div>
                ) : this.state.isLoadingMachines ? (
                  <div className="text-center p-5">
                    <Loader />
                    <p className="mt-2 text-muted">Loading exhibitor machines and stall details...</p>
                  </div>
                ) : (
                  <>
                    {/* Machine Form Section - Styled exactly like spacebooking.js without additional CSS */}
                    <div className="card shadow-none border rounded-2 mb-3">
                      <div className="card-body p-3">
                        {/* Row 1: Company Name, Country, Type Checkboxes */}
                        <div className="row mb-3 gx-3 align-items-start">
                          <div className="col-md-4">
                            <label className="form-label-exhdetail border-0">
                              Manufacturing/Exhibiting Company Name<span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={'200'}
                              placeholder="e.g. Acme Corp"
                              value={this.state.machineForm.ManufacturerName}
                              style={{ border: this.state.machineFormErrors.ManufacturerName && '2px solid red' }}
                              onChange={(e) => this.onMachineFieldChange('ManufacturerName', e.target.value)}
                            />
                            {this.state.machineFormErrors.ManufacturerName && (
                              <span className="text-danger d-block mt-1" style={{ fontSize: '11px' }}>{this.state.machineFormErrors.ManufacturerName}</span>
                            )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label-exhdetail border-0">
                              Manufacturing Country/Country Of Origin<span className="text-red">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={this.state.machineForm.ManufacturingCountry}
                              style={{ border: this.state.machineFormErrors.ManufacturingCountry && '2px solid red' }}
                              onChange={(e) => this.onMachineFieldChange('ManufacturingCountry', e.target.value)}
                            >
                              <option value="">Select Country</option>
                              {this.state.countryList && this.state.countryList.map((c, cIdx) => (
                                <option key={cIdx} value={c.Description || c.Country || c.CountryName || c.Code}>
                                  {c.Description || c.Country || c.CountryName || c.Code}
                                </option>
                              ))}
                              {this.state.machineForm.ManufacturingCountry &&
                                !this.state.countryList?.some(c => (c.Description || c.Country || c.CountryName || c.Code) === this.state.machineForm.ManufacturingCountry) && (
                                  <option value={this.state.machineForm.ManufacturingCountry}>{this.state.machineForm.ManufacturingCountry}</option>
                                )}
                            </select>
                            {this.state.machineFormErrors.ManufacturingCountry && (
                              <span className="text-danger d-block mt-1" style={{ fontSize: '11px' }}>{this.state.machineFormErrors.ManufacturingCountry}</span>
                            )}
                          </div>

                          <div className="col-md-4">
                            <div className="border p-0 rounded-2">
                              <label className="form-label-exhdetail border-0 d-block border-bottom p-2 mb-0">
                                Machine/Products/Only Brochure<span className="text-red">*</span>
                              </label>
                              <div className="d-flex align-items-center p-2 gap-3 flex-wrap">
                                <div className="d-flex align-items-center">
                                  <input
                                    className="toggle-box mt-0 me-1"
                                    id="chkMachineModal"
                                    type="checkbox"
                                    checked={this.state.machineForm.isMachine}
                                    onChange={() => this.onMachineTypeToggle('isMachine')}
                                  />
                                  <label className="form-check-label checkbox-label border-0 mb-0" htmlFor="chkMachineModal">
                                    Machine
                                  </label>
                                </div>
                                <div className="d-flex align-items-center">
                                  <input
                                    className="toggle-box mt-0 me-1"
                                    id="chkProductModal"
                                    type="checkbox"
                                    checked={this.state.machineForm.IsAccessory}
                                    onChange={() => this.onMachineTypeToggle('IsAccessory')}
                                  />
                                  <label className="form-check-label checkbox-label border-0 mb-0" htmlFor="chkProductModal">
                                    Product
                                  </label>
                                </div>
                                <div className="d-flex align-items-center">
                                  <input
                                    className="toggle-box mt-0 me-1"
                                    id="chkBrochureModal"
                                    type="checkbox"
                                    checked={this.state.machineForm.isBrochure}
                                    onChange={() => this.onMachineTypeToggle('isBrochure')}
                                  />
                                  <label className="form-check-label checkbox-label border-0 mb-0" htmlFor="chkBrochureModal">
                                    Only Brochure
                                  </label>
                                </div>
                              </div>
                            </div>
                            {this.state.machineFormErrors.machineType && (
                              <span className="text-danger d-block mt-1" style={{ fontSize: '11px' }}>{this.state.machineFormErrors.machineType}</span>
                            )}
                          </div>
                        </div>

                        {/* Row 2: Machine Details & HSN, Dimensions Table, Floor Loading & Weight, Certificate Upload */}
                        <div className="row mb-3 gx-3 align-items-stretch">
                          {/* Col 1: Machine Details & HSN Code */}
                          <div className="col-md-3 d-flex flex-column justify-content-between">
                            <div className="mb-2">
                              <label className="form-label-exhdetail border-0">Machine Details</label>
                              <input
                                type="text"
                                className="form-control"
                                maxLength={'200'}
                                placeholder="Model / Name / Specs"
                                value={this.state.machineForm.MachineDetails}
                                onChange={(e) => this.onMachineFieldChange('MachineDetails', e.target.value)}
                              />
                            </div>
                            <div className="mb-0">
                              <label className="form-label-exhdetail border-0">HSN Code</label>
                              <input
                                type="text"
                                className="form-control"
                                maxLength={'200'}
                                placeholder="HSN code"
                                value={this.state.machineForm.HSNCode}
                                onChange={(e) => this.onMachineFieldChange('HSNCode', e.target.value)}
                              />
                            </div>
                          </div>

                          {/* Col 2: Machine Dimension (mtr) */}
                          <div className="col-md-4">
                            <div className="nested-card h-100">
                              <div className="nested-card-title">
                                Machine Dimension (mtr){this.state.machineForm.isMachine && <span className="text-red">*</span>}
                              </div>
                              <div className="table-like">
                                <div className="table-col">
                                  <div className="table-label">Length{this.state.machineForm.isMachine && <span className="text-red">*</span>}</div>
                                  {(this.state.machineForm.isBrochure || this.state.machineForm.IsAccessory) && !this.state.machineForm.isMachine ? (
                                    <input type="text" className="form-control" maxLength={'9'} value={0} disabled={true} />
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={this.state.machineForm.Length}
                                      style={{ border: this.state.machineFormErrors.Length && '2px solid red' }}
                                      disabled={!this.state.machineForm.isMachine}
                                      onChange={(e) => this.onMachineDimensionChange('Length', e.target.value)}
                                    />
                                  )}
                                </div>
                                <div className="table-col">
                                  <div className="table-label">Breadth{this.state.machineForm.isMachine && <span className="text-red">*</span>}</div>
                                  {(this.state.machineForm.isBrochure || this.state.machineForm.IsAccessory) && !this.state.machineForm.isMachine ? (
                                    <input type="text" className="form-control" maxLength={'9'} value={0} disabled={true} />
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={this.state.machineForm.Breadth}
                                      style={{ border: this.state.machineFormErrors.Breadth && '2px solid red' }}
                                      disabled={!this.state.machineForm.isMachine}
                                      onChange={(e) => this.onMachineDimensionChange('Breadth', e.target.value)}
                                    />
                                  )}
                                </div>
                                <div className="table-col">
                                  <div className="table-label">Area{this.state.machineForm.isMachine && <span className="text-red">*</span>}</div>
                                  <input
                                    type="text"
                                    className="form-control area-input"
                                    value={this.state.machineForm.Area || 0}
                                    disabled
                                  />
                                </div>
                                <div className="table-col">
                                  <div className="table-label">Height{this.state.machineForm.isMachine && <span className="text-red">*</span>}</div>
                                  {(this.state.machineForm.isBrochure || this.state.machineForm.IsAccessory) && !this.state.machineForm.isMachine ? (
                                    <input type="text" className="form-control" maxLength={'9'} value={0} disabled={true} />
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={this.state.machineForm.Height}
                                      style={{ border: this.state.machineFormErrors.Height && '2px solid red' }}
                                      disabled={!this.state.machineForm.isMachine}
                                      onChange={(e) => this.onMachineDimensionChange('Height', e.target.value)}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="text-center text-muted py-1" style={{ fontSize: '10px' }}>
                                Dimensions disabled for Product / Only Brochure
                              </div>
                            </div>
                          </div>

                          {/* Col 3: Floor Loading & Machine Weight */}
                          <div className="col-md-2 d-flex flex-column justify-content-between">
                            <div className="mb-2">
                              <label className="form-label-exhdetail border-0">Floor Loading (Kgs/Sqm)</label>
                              {(this.state.machineForm.isBrochure || this.state.machineForm.IsAccessory) && !this.state.machineForm.isMachine ? (
                                <input type="text" className="form-control" maxLength={'9'} value={0} disabled={true} />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={'9'}
                                  placeholder="0"
                                  disabled={!this.state.machineForm.isMachine}
                                  value={this.state.machineForm.FloorCapacity}
                                  onChange={(e) => this.onMachineFieldChange('FloorCapacity', e.target.value)}
                                />
                              )}
                            </div>
                            <div className="mb-0">
                              <label className="form-label-exhdetail border-0">Machine Weight (Kg)</label>
                              {(this.state.machineForm.isBrochure || this.state.machineForm.IsAccessory) && !this.state.machineForm.isMachine ? (
                                <input type="number" className="form-control" maxLength={'9'} value={0} disabled={true} />
                              ) : (
                                <input
                                  type="number"
                                  className="form-control"
                                  maxLength={'9'}
                                  placeholder="0"
                                  disabled={!this.state.machineForm.isMachine}
                                  value={this.state.machineForm.MachineWeight}
                                  onChange={(e) => this.onMachineFieldChange('MachineWeight', e.target.value)}
                                />
                              )}
                            </div>
                          </div>

                          {/* Col 4: Upload Certificate */}
                          <div className="col-md-3">
                            <div className="nested-card h-100">
                              <div className="nested-card-title text-white" style={{ background: '#3dbca7' }}>
                                Upload Certificate of Origin / Manufacturing license{(this.state.machineForm.isMachine || this.state.machineForm.IsAccessory) && <span className="text-red">*</span>}
                              </div>
                              <div className="d-flex flex-column align-items-center justify-content-center p-3 flex-grow-1">
                                {this.state.machineForm.DocumentName || (this.state.machineForm.DocDeleted == false && this.state.machineForm.DocumentPath) ? (
                                  <div style={{
                                    border: '1px solid #ccc',
                                    padding: '6px 12px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    borderRadius: '4px',
                                    maxWidth: '100%'
                                  }}>
                                    {this.state.machineForm.DocDeleted == false && this.state.machineForm.DocumentPath ? (
                                      <a href={this.state.machineForm.DocumentPath} target="_blank" rel="noopener noreferrer" className="text-truncate" style={{ maxWidth: '160px' }}>
                                        <span style={{ marginRight: '10px' }}>{this.state.machineForm.DocumentName}</span>
                                      </a>
                                    ) : (
                                      <span className="text-truncate" style={{ marginRight: '10px', maxWidth: '160px' }}>{this.state.machineForm.DocumentName}</span>
                                    )}
                                    <i className="fa fa-times text-danger img-can" style={{ cursor: 'pointer' }} onClick={this.onRemoveMachineDoc}></i>
                                  </div>
                                ) : (
                                  <>
                                    <input
                                      type="file"
                                      id="machineDocFileModal"
                                      className="image-upload"
                                      accept=".jpg,.jpeg,.png,.pdf"
                                      onChange={this.onMachineFilePick}
                                      hidden
                                    />
                                    <button
                                      type="button"
                                      className="choose-file-btn"
                                      style={{ background: '#3dbca7' }}
                                      onClick={() => document.getElementById("machineDocFileModal").click()}
                                    >
                                      <i className="fa fa-cloud-upload me-1"></i> Choose File
                                    </button>
                                    <div className="text-muted mt-2 text-center" style={{ fontSize: '10px' }}>
                                      Max 5MB | PDF, JPEG, JPG, PNG
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="modal-footer d-flex justify-content-between">
                <div>
                  <button
                    className="btn btn-aqua"
                    onClick={this.handleAddOrUpdateMachineInList}
                    disabled={this.state.isSavingMachine}
                  >
                    {this.state.isSavingMachine ? "Saving..." : "Save"}
                  </button>
                  <button
                    className="btn btn-gray mx-2"
                    onClick={this.handleCloseAddMachineModal}
                    disabled={this.state.isSavingMachine}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getVendorExhibitionList_action,
    markOrderSeen_action,
    raiseManualForm_action,
    markManualFormInvoicePaid_action,
    primaryChapterAdd_action,
    getPreviewDetails_action,
    deleteChapterDoc_action,
  })(VendorExhibitionList)
);

